<template>
  <header role="header" id="header">
    <div class="header__inner">
      <!-- logo -->
      <router-link :to="{name: 'homePage' }" class="header__title">
        <img width="92px" height="50px" src="@/assets/TME LOGO.png" class="header__logo">
        <span class="header__text">{{ $t('header.title') }}</span>
      </router-link>

      <!-- 导航 -->
      <ul class="header__nav" role="nav">
        <li class="header__nav-item">
          <router-link :to="{name: 'homePage' }" class="header__nav-link">{{ $t('header.home') }}</router-link>
        </li>
        <li class="header__nav-item">
          <router-link v-if="hasLogin" :to="{name: 'guidePage'}" class="header__nav-link">
            {{ $t('header.about') }}
          </router-link>
          <span v-else class="header__nav-link" @click="handleLogin">{{ $t('header.about') }}</span>
        </li>
      </ul>

      <!-- 个人模块 -->
      <div class="header__person" :class="{'admin': isAdmin}">
        <div v-if="hasLogin" class="header__person--logined">
          <router-link v-if="isAdmin" class="platform" :to="{path: platformPath}">{{ platformName }}</router-link>
          <img
            v-if="userInfo.figureurl"
            class="header__person_cover"
            :alt="userInfo.username"
            :src="userInfo.figureurl"
            width="30px"
            height="30px"
          >
          <div class="header__notice">
            <el-badge :hidden="noticeNum === 0" :value="noticeNum" :max="99" class="item">
              <i class="el-icon-message-solid" style="color: #fff;" @click="handleToNotice" />
            </el-badge>
          </div>
          <span class="header__person_name header__person_text" :title="userInfo.username">{{ userInfo.username }}</span>
          <a href="javascript:;" class="header__person_text" @click="handleLogout">{{ $t('header.logout') }}</a>
        </div>
        <div v-else class="header__person--unlogin">
          <el-button type="primary" round @click="handleLogin">{{ $t('header.login') }}</el-button>
        </div>

        <section class="translate-wrapper" @click="handleChangeLang">
          <img
            width="26px"
            height="26px"
            src="@/assets/images/translate.png"
            alt=""
          >
          <span>{{ $t('header.language') }}</span>
        </section>
      </div>
    </div>

    <login ref="login"></login>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { logout } from '@/utils/auth'
import { ls } from '@/utils/index'
import Login from '@/components/Login/index.vue'

export default {
  name: 'AppHeader',

  components: {
    Login,
  },

  data() {
    return {
      lang: 'zh',
    }
  },
  computed: {
    ...mapGetters([
      'hasLogin',
      'userInfo',
      'showLogin',
      'isAdmin',
      'noticeNum'
    ]),
    ...mapState({
      redirectUrl: state => state.user.redirectUrl,
    }),
    platformPath() {
      return this.$route.path.startsWith('/admin') ? '/' : '/admin'
    },
    platformName() {
      return this.$route.path.startsWith('/admin') ? '系统前台' : '管理后台'
    },
    isPerson() {
      return this.$route.path.startsWith('/person')
    },
  },
  watch: {
    showLogin(newVal) {
      if (newVal) {
        console.log('header showLogin', newVal)
        this.$refs.login.open()
      }
    }
  },
  created() {
    this.lang = ls.getItem('lang', 'zh')
  },
  mounted() {
    if (this.showLogin) {
      this.$refs.login.open()
    }
  },
  methods: {
    handleLogout() {
      logout()
    },

    handleLogin() {
      this.$store.commit('login', true)
    },

    handleToNotice() {
      // * https://github.com/vuejs/vue-router/issues/2872
      this.$router.push({ name: 'personNotice' }).catch(() => {})
    },

    handleChangeLang() {
      this.lang = this.lang === 'zh' ? 'en' : 'zh'
      ls.setItem('lang', this.lang)
      this.$root.$i18n.locale = this.lang
      location.reload()
    }
  }
}
</script>

<style lang="scss">
#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #000;
  z-index: 2000;
  color: #fff;

  .header__inner {
    position: relative;
    height: 60px;
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
  }

  .header__title {
    display: inline-flex;
    margin-left: -16px;
  }
  .header__logo {
    margin: 5px 0;
    vertical-align: bottom;
  }
  .header__text {
    font-size: 20px;
    color: #fff;
    line-height: 60px;
  }

  .header__nav {
    position: absolute;
    left: 270px;
    top: 0;
  }

  .header__nav-item {
    float: left;
  }

  .header__nav-link {
    position: relative;
    display: block;
    padding: 0 35px;
    line-height: 60px;
    width: 200px;
    height: 60px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    -moz-osx-font-smoothing: subpixel-antialiased;
    -webkit-font-smoothing: subpixel-antialiased;

    &::after {
      content: "";
      position: absolute;
      top: 50px;
      left: 50%;
      width: 72px;
      height: 2px;
      background-color: #fff;
      transform: translateX(-50%);
      opacity: 0;
    }

    &.router-link-active {
      &::after {
        opacity: 1;
      }
    }
  }

  .platform {
    margin-right: 14px;
    color: #fff;
    font-size: 14px;
  }

  .header__person {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 360px;

    &.admin {
      width: 420px;
    }
  }

  .header__person--unlogin {
    display: inline-block;
    // margin-top: 16px;
  }

  .header__person--logined {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .header__person_cover {
    margin-right: 16px;
    border-radius: 20px;
  }
  .header__person_name {
    padding-left: 10px;
    margin: 0 20px 0 30px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100px;

  }
  .header__person_text {
    // float: left;
    color: #fff;
    font-weight: 400;
    -webkit-font-smoothing: subpixel-antialiased;
  }
  .header__notice {
    text-align: left;

    .el-icon-message-solid {
      cursor: pointer;
      font-size: 20px;
    }
    /deep/ el-badge__content {
      height: 14px;
      line-height: 14px;
    }
  }

  .translate-wrapper {
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-size: 14px;
    -webkit-font-smoothing: subpixel-antialiased;
    cursor: pointer;

    span {
      margin-left: 4px;
    }
  }
}

@media screen and (max-width: 1400px) {
  #header {
    .header__nav-link {
      width: 160px;
      padding: 0 16px;
    }
  }
}

</style>
